<template>
  <div>
    <b-row class="m-0">
      <b-col cols="12" md="5" class="my-2">
        <div class="p-3">
          <div class="text-justify mb-3">
            <strong class="fs_16" v-text="$lang.finalReportAttitudeTitle" />
            <span
              class="text-muted lh_30"
              v-text="finalReportAttitudeCaption"
            />
          </div>
          <i :class="`far fa-check-circle mr-2`" />
          <strong class="text-right" v-html="renderScore()" />
        </div>
      </b-col>
      <b-col cols="12" md="7" class="my-2">
        <ChartLineProgress :data="data" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ChartLineProgress from "./chartLineProgress";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    ChartLineProgress,
  },
  data() {
    return {
      data: [],
      code: this.$route.params.code,
      attitudeData: {},
      finalReportAttitudeCaption: ` تصور فرد در مورد اینکه چه رفتار‌هایی درست یا غلط است، هر چقدر که تمایل فرد به نشان دادن رفتارهای غلط بیشتر باشد احتمال وقوع این رفتارها بیشتر می‌شود. کسانی در سنجش صورت گرفته نمره پایین کسب می‌کنند که انجام دادن برخی از رفتارهای غلط مشکلی ندارند و زمینه آماده تری برای انجام دادن آن‌ها از خود نشان می‌دهند.
  نتایج مقابل مبتنی بر خود اظهاری افراد از طریق آزمون بر خط تهیه شده است.`,
    };
  },

  methods: {
    pathOr,
    generateApiUrl,
    async getAzmoonExecutePersonResult() {
      try {
        const url = generateApiUrl(
          ["report", "report_person_result"],
          [this.code]
        );
        const response = await this.$httpService.get(url);
        this.data = response.data.data.result;
      } catch (error) {
        this.$generateError(error);
      }
    },
    renderScore() {
      const data = {
        خوب: "text-success",
        متوسط: "text-warning",
        ضعیف: "text-danger",
      };
      const score = pathOr("", ["score"], this.attitudeData);
      const cls = pathOr("text-secondary", [score], data);
      return this.$lang.finalReportAttitudeScore.replace(
        "{0}",
        `<span class="${cls}">${score}</span>`
      );
    },
    async fetchData() {
      try {
        this.$emit("setLoading", true);
        const url =
          this.$config.api_url +
          this.$config.report.final_report_attitude.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        this.attitudeData = {
          ...pathOr({}, ["data", "data"], response),
        };
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("setLoading", false);
      }
    },
  },
  created() {
    this.fetchData();
    this.getAzmoonExecutePersonResult();
  },
};
</script>

